import { HighlightLastWord } from "@/cms/textHelpers";

export default function AboutHero({ fields = {} }) {
  const {
    eyebrow = "Who We Are",
    headline = "About Exqura",
    subtext = "We are your premier concierge for golfing experiences — curating unforgettable rounds at the world's most prestigious courses with seamless end-to-end service.",
    backgroundImage = "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1920&q=80",
  } = fields;

  return (
    <section className="relative py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{ backgroundImage: `url('${backgroundImage}')` }}
      />
      <div className="relative max-w-4xl mx-auto text-center">
        <p className="text-[#D4AF37] text-sm font-semibold tracking-widest uppercase mb-4">
          {eyebrow}
        </p>
        <h1 className="text-white font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight mb-6">
          <HighlightLastWord text={headline} />
        </h1>
        <p className="text-white/70 text-lg sm:text-xl leading-relaxed max-w-2xl mx-auto whitespace-pre-line">
          {subtext}
        </p>
      </div>
    </section>
  );
}
